const placeholderCls = "futpj2rlxf";
const togglerCls = "futt1ydu9f9";

export { placeholderCls, togglerCls };
import "./_dropdown.styles.linaria.module.css";
//# sourceMappingURL=_dropdown.styles.js.map
